import { render, staticRenderFns } from "./WebDesign.vue?vue&type=template&id=36e7ef12&scoped=true&"
import script from "./WebDesign.vue?vue&type=script&lang=js&"
export * from "./WebDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e7ef12",
  null
  
)

export default component.exports